import axios from "axios";
import { addHeaders } from "./session";
import { AppConfig } from "_config/AppConfig";

const client = axios.create({
  baseURL: AppConfig.SERVICE_BASE_URL
});
export default client


client.interceptors.request.use(
  config => addHeaders(config)
)

export const updateAxiosInstanceHeader = (headerName, headerValue) => {
  const currentHeaders = {...client.defaults.headers};

  currentHeaders[headerName] = headerValue;

  client.defaults.headers = currentHeaders;
};

export const deleteAxiosInstanceHeader = (headerName) => {
  const currentHeaders = {...client.defaults.headers};

  delete currentHeaders[headerName]

  client.defaults.headers = currentHeaders;
}